import { BaseService } from './base.service'

export class UsersService extends BaseService {

  static get entity () {
    return 'users'
  }

  static changePassword(id, password) {
    return new Promise((resolve, reject) => {
      return this.request().post(`${this.entity}/password`, {
        userId: id,
        password: password
      })
      .then(response => resolve(this.responseWrapper(response)))
      .catch(error => reject(this.errorWrapper(error)))
    });
  }

  static getCurrent () {
    return new Promise((resolve, reject) => {
      return this.request().get(`${this.entity}/current`)
        .then(response => resolve(response.data.data))
        .catch(error => {
          reject(error);
        })
    })
  }

  static removeToken(id, tokenUid) {
    return new Promise((resolve, reject) => {
      return this.request().post(`${this.entity}/revoke`, {
        userId: id,
        tokenUid: tokenUid
      })
      .then(response => resolve(this.responseWrapper(response)))
      .catch(error => reject(this.errorWrapper(error)))
    });
  }

  static uploadAvatar(id, file) {
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('userId', id);
      return this.request().post(`${this.entity}/upload-avatar`, formData)
          .then(response => resolve(this.responseWrapper(response)))
          .catch(error => reject(this.errorWrapper(error)))
    });
  }
}
